import Image from 'app/Components/Shared/Image/image';
import React, {memo} from 'react';
import './GenreCard.scss';

const GenreCard = ({ genre = {} }) => {
  return (
    <div className="genre-card">
      <div className="card-shadow-group">
        <div className="card-shadow-back"></div>
        <div className="card-shadow-front"></div>
      </div>
      <div
        className="card-content"
      >
        {genre.image && (
          <Image src={genre.image}
            alt={genre.title}
            className="card-image" />
        )}
        <span
          className="card-title"
          style={{
            color: genre.textColor || '#000000'
          }}
        >
          {genre.title}
        </span>
      </div>
    </div>
  );
};

export default memo(GenreCard);
